import React from 'react'
import abimg from '../../images/home/homeImage2.png'
// import VideoModal from '../ModalVideo'
import './style.css'

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  }
  return (
    <div className="wpo-about-area section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 colsm-12">
            <div className="wpo-about-text">
              <div className="wpo-section-title">
                {/* <span>What We Do?</span> */}
                <h2>About Us</h2>
              </div>
              <p>Nirbaak is a vibrant social and cultural organization dedicated to the timeless art of mime—the powerful language of silence and expression. Since its inception in 2018, Nirbaak has been passionately committed to using this unique art form to communicate stories, emotions, and critical social messages without words.</p>
              <p>Through evocative street performances and theatrical shows, Nirbaak brings to life pressing social issues such as AIDS, COVID-19, cancer, cybercrime, child marriage, environmental conservation, road safety, and drug abuse. Their performances transcend language barriers, touching hearts and inspiring awareness and change in communities.</p>
              <div className="btns">
                <a href="/about" className="theme-btn" onClick={ClickHandler}>Learn More</a>
                {/* <ul>
                  <li className="video-holder">
                    <VideoModal />
                  </li>
                  <li className="video-text">
                    Watch Our Video
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 colsm-12">
            <div className="wpo-about-img-3">
              <img src={abimg} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About;